import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Container } from 'reactstrap';
import { useIntl } from 'react-intl';

import { APIgetUploadPage } from '../../api/UploadPages';

import AdminBreadcrumbs from '../../components/Admin/Breadcrumbs';

import Loading from '../../components/Loading';
import UploadPageDetailsTabs from '../../components/Admin/UploadPages/UploadPageDetailsTabs';
import UploadPageDetailsTabContent from '../../components/Admin/UploadPages/UploadPageDetailsTabContent';

const UploadPageDetails = ({ match }) => {
  const [activeTab, setActiveTab] = useState('collected-details');
  const [uploadPage, setUploadPage] = useState(null);
  const [uploadPageLoading, setUploadPageLoading] = useState(true);

  const intl = useIntl();

  const { uploadPageUuid } = match.params;

  useEffect(() => {
    setUploadPageLoading(true);
    APIgetUploadPage(uploadPageUuid).then((response) => {
      const { data } = response;
      setUploadPage(data);
    }).catch(() => {
      setUploadPage(null);
    }).finally(() => {
      setUploadPageLoading(false);
    });
  }, [uploadPageUuid]);

  return (
    <div className="main-content upload-pages-content upload-page-details-content">
      <Container fluid>
        <AdminBreadcrumbs />
        <header className="page-header">
          <h2 className="page-title">
            <i className="far fa-arrow-up-from-bracket" />
            {intl.formatMessage({ defaultMessage: 'Guest upload page details' })}
          </h2>
        </header>
        {uploadPageLoading ? (
          <Loading />
        ) : (
          <div className="content-wrapper">
            <UploadPageDetailsTabs
              handleSwitchTab={setActiveTab}
              activeTab={activeTab}
            />
            <UploadPageDetailsTabContent
              uploadPage={uploadPage}
              activeTab={activeTab}
            />
          </div>
        )}
      </Container>
    </div>
  );
};

UploadPageDetails.propTypes = {
  match: PropTypes.object.isRequired,
};

export default withRouter(UploadPageDetails);
